import { Component, OnInit,Input } from '@angular/core';

@Component({
  selector: 'app-ui-loading-spinner',
  templateUrl: './ui-loading-spinner.component.html',
  styleUrls: ['./ui-loading-spinner.component.sass']
})
export class UiLoadingSpinnerComponent implements OnInit {
  @Input('className') className: string;
  constructor() { }

  ngOnInit(): void {
  }

}
